﻿import React from 'react';

import styled from 'styled-components';
import {connect} from 'react-redux';

import {GuideFormBase, connectForm} from './GuideFormBase';
import NumberInput from '../../../Forms/Components/NumberInput';

import definitions from '../../../Style/LfStyleDefinitions';
import {required} from '../../../Forms/Validation/rules';

class Step1Form extends GuideFormBase {
    render() {
        const StepForm = this.stepFormWrapper;

        return (
            <StepForm heading="Hur gammal är du?">
                <NumberInput
                    theme="big"
                    innerLabel="år"
                    id="age"
                    name="age"
                    min="1"
                    step="1"
                    data-validation-error-message="Ange din ålder"
                    validations={[required]}
                    placeholder="0"
                    value={this.props.formData.age}
                />
            </StepForm>
        );
    }
}

export default connectForm({ formClass: Step1Form, guideStep: 1 });